import React, {Component} from 'react';
import DaysBackStoredFilter from '../components/DaysBackStoredFilter';
import VIPUsageTable from '../components/VIPUsageReport';
import {hasReportsAccess} from '../shared/authFunctions';
import {displayDateRangeStringFromDates} from '../shared/functions';
import FuseTheme from '../global/theme';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/card-membership';

const styles = {
    button: {color: FuseTheme.palette.primary3Color},
    removeSpacing: {paddingTop: '0'}
};

/**
 * VIP Usage class for retrieving and displaying summary
 *
 */
class VIPUsageReports extends Component {
    constructor(props) {
        super(props);
        const system = localStorage.getItem('system');
        const vipUsageDaysBack = localStorage.getItem('vipUsage_days_back');
        const daysBack = (vipUsageDaysBack) ? vipUsageDaysBack : '30';
        if (daysBack !== vipUsageDaysBack) {
            localStorage.setItem('vipUsage_days_back', daysBack);
        }
        this.state = {
            daysBack: daysBack,
            errorMessage: null,
            summaryComplete: false,
            system: system,
        };
    }

    /**
     * Handle event props for Table completion
     *
     * @param isComplete
     */
    handleSummaryComplete = (isComplete) => {
        this.setState({
            summaryComplete: isComplete,
        });
    };

    handleReportError = (message) => {
        this.setState({
            errorMessage: message,
            summaryComplete: true,
        });
    };

    handleDaysBackSelect = (days) => {
        this.setState({daysBack: days});
        localStorage.setItem('vipUsage_days_back', days);
    }

    render() {
        const {
            daysBack,
            errorMessage,
            summaryComplete,
            system
        } = this.state;

        // As a Dashboard component, do not display if user lacks access
        if (!hasReportsAccess())  return <div></div>;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>VIP Usage Report</span>;

        const ListDescription = () => {
            const days = (daysBack === '1') ? 'day' : 'days';
            const today = new Date();
            const back = new Date();
            back.setDate(back.getDate() - parseInt(daysBack, 10));
            const dateRange = displayDateRangeStringFromDates(back, today);
            return (
                <span className="list-description hide-print">
                    <p>A VIP Usage Report displays total number of Purchases by VIP customers and a Percentage breakdown of Purchases by each location for the past {daysBack} {days}.</p>
                    <p>({dateRange})</p>
                </span>
            );
        };

        return (
            <div className="lists-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText style={styles.removeSpacing}>
                        <ListDescription/>
                        <DaysBackStoredFilter
                            daysBack={daysBack}
                            onSelectDaysBack={this.handleDaysBackSelect}
                            reportName="vipUsage"
                        />

                        {/* Report Loader, and messaging */}
                        {!summaryComplete &&
                            <div className="loader-container">
                                <h4>Generating Report...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                        }

                        {/* VIP Usage Content */}
                        <VIPUsageTable
                            daysBack={daysBack}
                            system={system}
                            onSummaryComplete={this.handleSummaryComplete}
                            onError={this.handleReportError}
                        />

                        {/* Error and Messaging */}
                        {errorMessage &&
                            <div className="error">
                                <p>{errorMessage}</p>
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}

export default VIPUsageReports;



// WEBPACK FOOTER //
// ./src/Fuse/Report/VIPUsageReports.js